import { ApolloError } from '@apollo/client'
import { summarizeApolloError } from '@deltek/specification-client/core/Utilities/apolloUtils'

export const handleFetchError = (
    error: ApolloError,
    defaultError: string = 'WorkspaceEditor-projectContentItemElements'
) => {
    const summarizedError = summarizeApolloError(error, defaultError)
    console.error(summarizedError)
}
